import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Deploy / launch icon.
 *
 * An upward arrow inside a rounded rectangle, conveying "launch"
 * or "deploy" of an application to a target environment.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Arrow body: cyan accent fill at 8%
 */
export const DeployIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Rounded rect frame */}
    <rect
      x={3}
      y={3}
      width={18}
      height={18}
      rx={3}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Upward arrow body with cyan accent fill */}
    <path
      d="M12 6 L12 17"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10 L12 6 L16 10"
      fill="#00d4ff"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

DeployIcon.displayName = "DeployIcon";

export default DeployIcon;
